module.exports = __webpack_public_path__ + "26a49e6a5f1bf15affa675749a4a7693.jpg";